import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useRouteMatch } from "react-router-dom";

import { theme } from "theme";
import { SparklesIcon } from "./icons";
import { AnnouncementAction, AnnouncementDetail } from "./styles";
import { useAppState } from "contextApi/appContext";
import { StickyBanner } from "components/common/styles";
import { CREATE_AI_NEW_UNTIL_MILLIS } from "constants/featureAnnouncements";
import { useComposerActions } from "contextApi/composerContext";
import { trackAnalyticsEvent } from "state/actions/AnalyticsActions";

const DISMISSED_STORAGE_KEY = "dismiss_feature_create_ai_banner";
const SHOWN_STORAGE_KEY = "shown_feature_create_ai_banner";

const CreateAiAnnouncement: React.FC = () => {
  const dispatch = useDispatch();
  const isOnDashboard = !!useRouteMatch({ path: "*/dashboard", exact: false });
  const showCreateAiChat = useAppState(state => state.showCreateAiChat) === true;
  const openComposer = useComposerActions(actions => actions.openComposer);
  const [isDismissed, setDismissed] = useState(() => !!window.localStorage.getItem(DISMISSED_STORAGE_KEY));
  const isAnnouncing = showCreateAiChat && isOnDashboard && !isDismissed && Date.now() < CREATE_AI_NEW_UNTIL_MILLIS;

  useEffect(() => {
    if (!isAnnouncing || window.localStorage.getItem(SHOWN_STORAGE_KEY)) return;
    window.localStorage.setItem(SHOWN_STORAGE_KEY, "true");
    dispatch(trackAnalyticsEvent("Create AI Announcement Shown"));
  }, [isAnnouncing, dispatch]);

  const hideForGood = useCallback(() => {
    window.localStorage.setItem(DISMISSED_STORAGE_KEY, "true");
    setDismissed(true);
  }, []);

  const closeAnnouncement = useCallback(() => {
    dispatch(trackAnalyticsEvent("Create AI Announcement Dismissed"));
    hideForGood();
  }, [dispatch, hideForGood]);

  const tryCreateAi = useCallback(() => {
    dispatch(trackAnalyticsEvent("Create AI Announcement Clicked"));
    hideForGood();
    openComposer();
  }, [dispatch, hideForGood, openComposer]);

  if (!isAnnouncing) return null;

  return (
    <StickyBanner $isVisible $background={theme.colors.primarySubtle} $textColor={theme.colors.primary}>
      <p>
        <em>
          <SparklesIcon size={16} style={{ color: theme.colors.primary }} />
          New: Create AI in the composer.
        </em>
        <AnnouncementDetail>Write, edit and schedule your post by chatting with it.</AnnouncementDetail>
        <AnnouncementAction type="button" onClick={tryCreateAi}>Try it</AnnouncementAction>
      </p>
      <i className="icon-cancel" onClick={closeAnnouncement} />
    </StickyBanner>
  );
};

export default CreateAiAnnouncement;
